import { useQuery } from "@tanstack/react-query"
import { FileQuestion } from "lucide-react"
import { useParams } from "react-router-dom"
import { getAdminPost } from "@/entities/admin-post"
import { useSessionRole } from "@/entities/session"
import { EditorSkeleton, PostEditor } from "@/features/edit-post"
import { AccessDenied } from "@/shared/ui/access-denied"
import { EmptyState } from "@/shared/ui/empty-state"
import { LoadErrorState } from "@/shared/ui/load-error-state"
import { LoadSwap } from "@/shared/ui/load-swap"

/** Редактирование материала. Файлы, которые уже загружены, меняются сразу, остальное по «Сохранить». */
export function EditPostPage() {
	const { id } = useParams<{ id: string }>()
	const { isAdmin } = useSessionRole()
	const query = useQuery({
		queryKey: ["admin-post", id],
		queryFn: () => getAdminPost(id!),
		enabled: !!id && isAdmin,
	})

	if (!isAdmin) return <AccessDenied title="Редактирование" />
	return (
		<LoadSwap
			loading={query.isLoading}
			id={query.isError ? "error" : query.data ? "ready" : "missing"}
		>
			{query.isLoading ? (
				<EditorSkeleton />
			) : query.isError ? (
				<div className="container mx-auto max-w-3xl px-3 py-8">
					<LoadErrorState onRetry={() => void query.refetch()} />
				</div>
			) : !query.data ? (
				<div className="container mx-auto max-w-3xl px-3 py-8">
					<EmptyState icon={FileQuestion} title="Материал не найден">
						Возможно, его удалили.
					</EmptyState>
				</div>
			) : (
				<PostEditor post={query.data} onReload={() => query.refetch()} />
			)}
		</LoadSwap>
	)
}
